import React from "react";
import FilledStar from "../../assets/images/filled-start.svg";
import HalfFilledStar from "../../assets/images/half-filled-star.svg";
import EmptyStar from "../../assets/images/empty-filled-star.svg";
import { useTranslation } from "react-i18next";

interface HotelReviewProps {
  title?: string;
  rating?: number;
  totalReviews?: number;
}

const renderStars = (rating: number) => {
  const normalized = (rating / 10) * 5;
  const stars = Array.from({ length: 5 }, (_, i) => {
    const diff = normalized - i;
    if (diff >= 0.75) return <img key={i} src={FilledStar} alt='Filled Star' />;
    if (diff >= 0.25)
      return <img key={i} src={HalfFilledStar} alt='Half Star' />;
    return <img key={i} src={EmptyStar} alt='Empty Star' />;
  });

  return stars;
};

const HotelReviewBox: React.FC<HotelReviewProps> = ({
  title,
  rating,
  totalReviews,
}) => {
  const { t } = useTranslation();
  return (
    <div className='review-box-flex'>
      <h3>{title}</h3>
      <div className='review-box'>
        <div className='review-flex'>
          <p>
            <span className='text'>{rating != null ? Number(rating).toFixed(2) : t("unrated")}</span>
            <span className='stars'>{renderStars(Number(rating) || 0)}</span>
          </p>
          <span className='border'></span>
          <p>
            <span className='text'>{totalReviews ?? 0}</span>
            <span>{t("reviews")}</span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default HotelReviewBox;
